"use strict";

/* globals $ */

var cache = {};

function initializeDom() {
    cache.$document = $(document);
    cache.$breedRefinementReset = cache.$document.find(".js-breed-refinement-reset");
    cache.$breedRefinementResetMobile = cache.$document.find(".js-breed-refinement-reset-mobile");
    cache.$breedRefinementFilter = cache.$document.find(".js-breed-refinement-filter");
    cache.$breedPagination = cache.$document.find(".js-breed-page");
    cache.$applyFilters = cache.$document.find(".js-apply-filters");
}

function onClickAction(event) {
    event.preventDefault();

    var $target = $(event.currentTarget);
    var url = $target.data("url");

    // security, do nothing if no url is provided
    // this should never happen, but just in case
    if (!url) {
        return;
    }

    $.spinner().start();
    // go to the provided url
    window.location.href = url;
}

function onFilterChange(event) {
    if (window.innerWidth <= 768) {
        return;
    }
    onClickAction(event);
}

function applyFilters(event) {
    event.preventDefault();

    var checkedFilters = cache.$breedRefinementFilter.filter(':checked');

    if (checkedFilters.length === 0) {
        var resetUrl = cache.$breedRefinementReset.data('url');
        if (resetUrl) {
            $.spinner().start();
            window.location.href = resetUrl;
        }
        return;
    }

    var filterGroups = {};

    checkedFilters.each(function() {
        var $filter = $(this);
        var filterName = $filter.attr('name');
        var filterValue = $filter.val();

        if (filterName && filterValue) {
            if (!filterGroups[filterName]) {
                filterGroups[filterName] = [];
            }
            filterGroups[filterName].push(filterValue);
        }
    });

    var baseUrl = window.location.href.split('?')[0];
    var currentParams = new URLSearchParams(window.location.search);
    var queryParams = [];

    // Add filter parameters
    var filterIndex = 1;
    Object.keys(filterGroups).forEach(function(filterName) {
        var mergedValue = filterGroups[filterName].join('|');
        queryParams.push('crefn' + filterIndex + '=' + encodeURIComponent(filterName));
        queryParams.push('crefv' + filterIndex + '=' + encodeURIComponent(mergedValue));
        filterIndex++;
    });

    // Add sort parameters (preserve from URL or use defaults)
    var csortb1 = currentParams.get('csortb1') || 'id';
    var csortd1 = currentParams.get('csortd1') || '1';
    queryParams.push('csortb1=' + encodeURIComponent(csortb1));
    queryParams.push('csortd1=' + encodeURIComponent(csortd1));

    var finalUrl = baseUrl + '?' + queryParams.join('&');

    $.spinner().start();
    window.location.href = finalUrl;
}

function initializeEvents() {
    cache.$breedRefinementReset.on("click", onClickAction);
    cache.$breedRefinementResetMobile.on("click", onClickAction);
    cache.$breedRefinementFilter.on("click", onFilterChange);
    cache.$breedPagination.on("click", onClickAction);
    cache.$applyFilters.on("click", applyFilters);
    initializeAccordion();
}

function initializeAccordion() {
    var pageBody = document.querySelector("body");
    var toggleFiltersButton = document.querySelector(".js-toggle-filters");
    var filters = document.querySelector(".filters");
    var filtersWrapper = document.querySelector(".filter-wrapper");
    var filterBackButton = document.querySelector(".filter-back-button");
    var productTiles = document.querySelector(".product-tiles");
    var toggleMenu = document.querySelector(".toggle-menu");
    var originalFilterState = [];

    toggleFiltersButton.addEventListener("click", function (event) {
        event.preventDefault();
        pageBody.classList.add("no-scroll");
        filters.classList.toggle("open");
        filtersWrapper.classList.toggle("filters-wrapper__mobile");
        filterBackButton.classList.toggle("show");
        if (productTiles) {
            productTiles.classList.toggle("hide");
        }
        if (toggleMenu) {
            toggleMenu.classList.toggle("show");
        }

        // Store the current state of all checkboxes
        originalFilterState = [];
        var checkboxes = document.querySelectorAll(".js-breed-refinement-filter");
        checkboxes.forEach(function(checkbox) {
            originalFilterState.push({
                element: checkbox,
                checked: checkbox.checked
            });
        });
    });

    filterBackButton.addEventListener("click", function (event) {
        event.preventDefault();
        pageBody.classList.remove("no-scroll");
        filters.classList.toggle("open");
        filtersWrapper.classList.toggle("filters-wrapper__mobile");

        // Restore original filter state without applying
        originalFilterState.forEach(function(state) {
            state.element.checked = state.checked;
        });
    });

    var accordions = document.getElementsByClassName("accordion");
    var i;

    for (i = 0; i < accordions.length; i++) {
        accordions[i].addEventListener("click", function (event) {
            event.preventDefault();
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.display === "block") {
                panel.style.display = "none";
            } else {
                panel.style.display = "block";
            }
        });

        // Add this line to open the accordion by default
        accordions[i].classList.add("active");
        accordions[i].nextElementSibling.style.display = "block";
    }
}

module.exports = {
    init: function () {
        initializeDom();
        initializeEvents();
    }
};
